import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Typography } from 'kangarootime-ui';
import { Query } from 'react-apollo';
import { GET_PUBLIC_CHANNELS_AT_CENTER } from '../../../../graphql/queries';
import Skeleton from 'react-skeletons';
import './ChannelsAtCenter.css';

const ChannelsAtCenterList = ({
  selectChannel,
  existingChannelMembershipIds,
  ...props
}) => {
  return (
    <Fragment>
      <Typography style={{ fontWeight: 600, fontSize: '0.875rem', marginTop: 8 }}>Channels you can join</Typography>
      <Query
        query={GET_PUBLIC_CHANNELS_AT_CENTER}
        variables={{ centerId: props.currentCenterId }}
        fetchPolicy='cache-and-network'
      >
        {({ loading, error, data: { getPublicChannels } }) => {
          if (loading) {
            return <Skeleton count={2} />;
          }

          const filteredChannels = getPublicChannels.filter(channel => !existingChannelMembershipIds.includes(channel.id));

          if (filteredChannels.length === 0) {
            return (
              <Typography>No additional channels found</Typography>
            );
          }

          return (
            <ul className='center-channels-list'>
              { filteredChannels.map(channel => (
                <li key={channel.id} onClick={() => selectChannel(channel)}>
                  <Typography type='bold'>#{channel.name}</Typography>
                  { channel.topic && <Typography type='meta'>{channel.topic}</Typography> }
                </li>
              ))}
            </ul>
          );
        }}
      </Query>
    </Fragment>
  );
};

function mapStateToProps (state) {
  return {
    currentCenterId: state.identity.centerId
  };
}

ChannelsAtCenterList.propTypes = {
  selectChannel: PropTypes.func,
  existingChannelMembershipIds: PropTypes.arrayOf(PropTypes.string)
};

export default connect(mapStateToProps)(ChannelsAtCenterList);
